<script setup lang="ts">
  /**
   * Layout shell for the "Billing And Invoicing" settings group.
   * Owns nothing but its title, icon, and the list of settings
   * rendered inside. Each setting below is a self-contained SFC —
   * editing this file doesn't require touching how a setting works.
   */

  import { IconInvoice } from '@gat-ship/icons'
  import SettingDefaultCurrency from './SettingDefaultCurrency.vue'
  import SettingDefaultPaymentTerms from './SettingDefaultPaymentTerms.vue'
</script>

<template>
  <section class="flex flex-col gap-2">
    <header class="flex items-center gap-2 px-1 pt-2">
      <IconInvoice class="size-5" :stroke-width="1.5" />
      <h3 class="text-base font-semibold tracking-wide">
        Billing And Invoicing
      </h3>
    </header>
    <div
      class="bg-background divide-input border-input divide-y overflow-hidden rounded-md border"
    >
      <SettingDefaultCurrency />
      <SettingDefaultPaymentTerms />
    </div>
  </section>
</template>
